import ImprimirTicket from './ImprimirTicketRealizado';
export default ImprimirTicket;